import async from 'async';
import * as actionTypes from '../constants/actionTypes';
import * as webService from '../services/webService';

const  receiveCookie = (payload) =>({
    type:actionTypes.RECEIVE_COOKIE,
    payload

})

export const getCookieDataInit = (dispatch) => {
    return new Promise ((resolve,failure)=>{
        async.series([
             (cb)=> {
                webService.getCookiePolicy().then((res)=>{
                    if(res.data.success){
                        cb (null,res.data.success)

                    }else {
                        cb(null,false)
                    }
                })
                    .catch((err)=>{
                        cb(null,false)
                    })


        }
        ], (err,result)=>{
            dispatch(receiveCookie(result[0]));
            resolve(result)
            }
        )

    })
}